var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0f4b73;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-476 -393)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(476 393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M283.328,312.253a1.151,1.151,0,0,1-.814-1.965l2.639-2.639-2.639-2.639a1.151,1.151,0,1,1,1.628-1.628l3.453,3.453a1.151,1.151,0,0,1,0,1.628l-3.453,3.453a1.148,1.148,0,0,1-.814.337Z",
    transform: "translate(226.277 108.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M253.478,317.85a1.151,1.151,0,0,1-1.151-1.151v-1.151a6.941,6.941,0,0,1,6.9-6.907H274.2a1.151,1.151,0,1,1,0,2.3H259.234a4.632,4.632,0,0,0-4.6,4.608V316.7a1.151,1.151,0,0,1-1.151,1.151Z",
    transform: "translate(237.708 105.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M266.26,332.774a1.147,1.147,0,0,1-.814-.337l-3.453-3.453a1.151,1.151,0,0,1,0-1.628l3.453-3.453a1.151,1.151,0,1,1,1.628,1.628l-2.639,2.639,2.639,2.639a1.151,1.151,0,0,1-.814,1.965Z",
    transform: "translate(234.136 100.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M264.672,327.178a1.151,1.151,0,1,1,0-2.3h14.964a4.632,4.632,0,0,0,4.6-4.608V319.12a1.151,1.151,0,1,1,2.3,0v1.151a6.941,6.941,0,0,1-6.9,6.907Z",
    transform: "translate(233.422 102.305)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegration);
export default __webpack_public_path__ + "static/media/icon-Integration.09f08de5679b7226dee9448346c8282c.svg";
export { ForwardRef as ReactComponent };